export const FERTILIZER_EVENT_WIZARD_SCHEDULE_STEP = 0;
export const FERTILIZER_EVENT_WIZARD_APPLICATION_STEP = 1;
export const FERTILIZER_EVENT_WIZARD_PRODUCT_STEP = 2;
export const FERTILIZER_EVENT_WIZARD_SUMMARY_STEP = 3;
